import { Text, type TextStyle } from 'react-native'

import { convertLineHeight, convertPercentageToNumber, styled } from '~/utils'

export const Label = styled(Text, theme => {
  const baseFontWeight = String(
    theme.fontWeightRegular
  ) as TextStyle['fontWeight']

  const semiboldFontWeight = String(
    theme.fontWeightSemibold
  ) as TextStyle['fontWeight']

  return {
    base: {
      flexShrink: 1,
      textAlign: 'left',
      fontFamily: 'RDModern-Regular',
      fontWeight: baseFontWeight,
      letterSpacing: convertPercentageToNumber(theme.letterSpacingDefault),
      paddingLeft: theme.paddingInsetTwopulse,
      color: theme.colorTextNeutralDefault,
    },
    variants: {
      size: {
        md: {
          fontSize: theme.fontSizeThreepulse,
          paddingLeft: theme.paddingInsetOnepulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreepulse,
            theme.lineHeightMedium
          ),
        },
        ml: {
          fontSize: theme.fontSizeThreeandhalfpulse,
          paddingLeft: theme.paddingInsetTwopulse,
          lineHeight: convertLineHeight(
            theme.fontSizeThreeandhalfpulse,
            theme.lineHeightSmall
          ),
        },
        lg: {
          fontSize: theme.fontSizeFourpulse,
          paddingLeft: theme.paddingInsetTwopulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFourpulse,
            theme.lineHeightSmall
          ),
        },
        xl: {
          fontSize: theme.fontSizeFourpulse,
          paddingLeft: theme.paddingInsetTwopulse,
          lineHeight: convertLineHeight(
            theme.fontSizeFourpulse,
            theme.lineHeightSmall
          ),
        },
      },
      hasError: {
        true: {
          fontWeight: semiboldFontWeight,
        },
      },
      hasDisabled: {
        true: {
          color: theme.colorTextNeutralDisabled,
        },
      },
      hasReadOnly: {
        true: {
          color: theme.colorTextNeutralReadonly,
        },
      },
    },
  }
})
